import styled from 'styled-components'

import * as V from '@styles/variables'

export const GithubRepositoriesWrapper = styled.div`
  padding-top: 0;
`
